import React, { AnchorHTMLAttributes, HTMLAttributes } from "react";
import Icon from "../../Foundation/Icon/Icon";
import Typography from "../../Foundation/Typography/Typography";
import { IconName } from "../../lib/svgIcon/components";
import { ShowMoreLinkRoot } from "./ShowMoreLink.styled";

export interface IShowMoreLinkProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  label?: string;
  color?: string;
  icon?: IconName;
  as?: string | React.ComponentType<any>;
  noIcon?: boolean;
  iconPosition?: "left" | "right";
  iconStyle?: React.CSSProperties;
}

const ShowMoreLink = (props: IShowMoreLinkProps) => {
  const {
    label = "Voir plus",
    icon = "plus",
    color = "#908271",
    noIcon,
    iconPosition = "left",
    iconStyle,
    ...rest
  } = props;
  const renderIcon = !noIcon && (
    <Icon icon={icon} color={color} size={16} style={iconStyle} />
  );

  return (
    <ShowMoreLinkRoot {...rest}>
      {iconPosition === "left" && renderIcon}
      <Typography
        color={() => color}
        variant="button2"
        style={{ marginTop: -3 }}
      >
        {label}
      </Typography>
      {iconPosition === "right" && renderIcon}
    </ShowMoreLinkRoot>
  );
};

export default ShowMoreLink;
